// extracted by mini-css-extract-plugin
module.exports = {"owl-carousel":"Products_owl-carousel__23Hrs","owlNext":"Products_owlNext__2rQXv","owlPrev":"Products_owlPrev__2zoj6","OwlCustom":"Products_OwlCustom__2nL-O"};